import { SportType } from './sport-type.model';

export class SkillLevel {
    constructor(
    public id: number,
   /*  public sportType: SportType, */
    public name: string,
    public description: string
    ){}
}
